import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const ConnectionCheck = React.lazy(async () => ({
    default: (await import('@oc/connection-check/module')).ConnectionCheckModule
}))

export function ConnectionCheckComponent() {
    return <SuspenseWhileLoading LazyComponent={ConnectionCheck} />
}
